import { render, staticRenderFns } from "./VirtualPubSection.vue?vue&type=template&id=45bd92c0&scoped=true"
import script from "./VirtualPubSection.vue?vue&type=script&lang=ts"
export * from "./VirtualPubSection.vue?vue&type=script&lang=ts"
import style0 from "./VirtualPubSection.vue?vue&type=style&index=0&id=45bd92c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd92c0",
  null
  
)

export default component.exports